export default __webpack_public_path__ + "static/media/Cat_and_Man.60dac897.jpg";